<template>
  <div class="wrapper f1 df fdc">
    <CompanyChangePlan v-if="planPage == 'ultimate'" v-on:changePlan="changePlan" v-bind:error="error"/>
    <CompanyChangePlanBasic v-if="planPage == 'basic'" v-on:changePlan="changePlan" v-bind:error="error"/>
    <CompanyChangePlanFree v-else-if="planPage == 'free'" v-on:changePlan="changePlanToFree"/>
  </div>
</template>

<script>
import SideBarProfile from '@/components/elements/SideBarProfile'
import CompanyChangePlan from '@/components/company/CompanyChangePlan'
import CompanyChangePlanBasic from '@/components/company/CompanyChangePlanBasic'
import CompanyChangePlanFree from '@/components/company/CompanyChangePlanFree'
const axios = require('axios')
import router from '@/router'

export default {
  name: 'DashboardChangePlan',
  data () {
    return {
      error: ''
      // mode: 'login' // login/register
    }
  },
  props: ['planPage'],
  components: {
    SideBarProfile,
    CompanyChangePlan,
    CompanyChangePlanBasic,
    CompanyChangePlanFree
  },
  methods: {
    goTo (path) {
      router.push(path)
    },
    changePlanToFree (data) {
      console.log('changeplantofree', data)
      // return false

      var _this = this

      axios.get('/changeplantofree', {
        params: {
          format: 'json',
          data
        }
      })
      .then(function (response) {
        // console.log('response', response);
        console.log('RESPONSE...2', response)
        _this.goTo('/pricing')
        _this.$router.go()
        console.log('after.....')
      })
      .catch(function (error) {
        console.log('ERROR', error.response);
      })
      .then(function () {
        // always executed
      }); 

    },
    changePlan (data) {
      axios.get('/createstripeclient', {
        params: {
          format: 'json',
          data
        }
      })
      .then((response) => {
        if (response.data.error) {
          this.error = response.data.error
          console.log('error ->', this.error)
        } else {
          console.log('no error')
        // _this.goTo('/pricing')
        // _this.$router.go()
        }
      })
      .catch(function (error) {
        console.log('ERROR...', error)
        // this.error = "Error creating customer. Check your payment details."
      })
      .then(function () {
        // always executed
      }); 
    }
  },
  computed: {

  },
  created () {
    // console.log('** Login Component Loaded')
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
}
.pricing-plan {
  min-height: 210px;
  margin-bottom: 50px;
}
.pricing-plan-left {
  background-color: #D9EDFF;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 40px 0;
}
.pricing-plan-right {
  & > span {
    padding: 40px;
    &:last-child {
      & > p {
        &:first-child {
          margin-bottom: 40px;
        }
      }
    }
  }
}
.feature {
  display: block;
  margin-bottom: 4px;
}
.number-of-things {
  color: #000000;
  font-size: 48px;
  line-height: 57px;
}
.plan-title {
  color: #000000;
  font-size: 36px;
  line-height: 42px;
}
.plan-price {
  color: #000000;
  font-size: 48px;
  line-height: 57px;
  position: relative;
  text-align: center;
  margin-top: 10px;

  & > sup {
    position: absolute;
    top: 14px;
    text-transform: uppercase;
    color: #000000;
    font-size: 14px;
    line-height: 4px;
  }
}
.plan-heading {
  color: #000000;
  font-size: 24px;
  line-height: 43px;
  margin-bottom: 5px;
}
</style>
